import { Grid } from '@mui/material';
import React from 'react';
import Color from './shared/Color';
import { UpdateFn } from './types';

type Props = {
	backgroundColor: string;
	updateBackgroundColor: UpdateFn;
};

const Containers = ({ backgroundColor, updateBackgroundColor }: Props) => (
	<Grid container spacing={2}>
		<Color
			label={intl.tr('styleEditor.containers.root.container.background')}
			hex={backgroundColor}
			onChange={updateBackgroundColor}
		/>
	</Grid>
);

export default Containers;
